export type MolecularStructureFormat =
  "mmcif" | "pdb" | "pdbqt" | "pqr" | "gro" | "xyz" | "mol" | "sdf" | "mol2";

export interface MolecularStructureSource {
  format: MolecularStructureFormat;
  binary: boolean;
}

const STRUCTURE_FORMATS: Record<string, MolecularStructureSource> = {
  ".bcif": { format: "mmcif", binary: true },
  ".cif": { format: "mmcif", binary: false },
  ".ent": { format: "pdb", binary: false },
  ".gro": { format: "gro", binary: false },
  ".mmcif": { format: "mmcif", binary: false },
  ".mol": { format: "mol", binary: false },
  ".mol2": { format: "mol2", binary: false },
  ".pdb": { format: "pdb", binary: false },
  ".pdbqt": { format: "pdbqt", binary: false },
  ".pqr": { format: "pqr", binary: false },
  ".sdf": { format: "sdf", binary: false },
  ".xyz": { format: "xyz", binary: false },
};

export function molecularStructureSource(filename: string): MolecularStructureSource | null {
  const normalized = filename.toLocaleLowerCase().replace(/\.gz$/, "");
  const suffix = Object.keys(STRUCTURE_FORMATS).find((item) => normalized.endsWith(item));
  return suffix ? STRUCTURE_FORMATS[suffix] : null;
}
